import React, { useState, useEffect, useRef } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

const QRScanner: React.FC = () => {
    const [scanResult, setScanResult] = useState<string | null>(null);
    const [validationResult, setValidationResult] = useState<string | null>(null);
    const scannerRef = useRef<Html5QrcodeScanner | null>(null);

    useEffect(() => {
        scannerRef.current = new Html5QrcodeScanner(
            "qr-scanner",
            { fps: 10, qrbox: { width: 250, height: 250 } },
            false
        );

        scannerRef.current.render(
            (decodedText) => {
                setScanResult(decodedText);
                validateQRCode(decodedText);
            },
            (errorMessage) => {
                console.error("QR Scan Error: ", errorMessage);
            }
        );

        return () => {
            scannerRef.current?.clear();
        };
    }, []);

    const validateQRCode = async (qrData: string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/qr/validate`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ QRId: qrData }),
            });

            const result = await response.json();
            if (response.ok) {
                setValidationResult(`✅ Adgang givet: ${result.message}`);
            } else {
                setValidationResult(`❌ Afvist: ${result.message}`);
            }
        } catch (error) {
            setValidationResult("⚠️ Fejl ved validering.");
        }
    };

    return (
        <div className="flex flex-col items-center p-6">
            <h1 className="text-2xl font-bold mb-4">QR-kode Scanning</h1>
            <div id="qr-scanner" className="border p-4"></div>

            {scanResult && (
                <div className="mt-4 p-4 border rounded bg-gray-100">
                    <h2 className="text-lg font-bold">Scannet QR-kode:</h2>
                    <p>{scanResult}</p>
                </div>
            )}

            {validationResult && (
                <div className={`mt-4 p-4 rounded ${validationResult.includes("✅") ? "bg-green-200" : "bg-red-200"}`}>
                    <h2 className="text-lg font-bold">Valideringsresultat:</h2>
                    <p>{validationResult}</p>
                </div>
            )}
        </div>
    );
};

export default QRScanner;
